import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconFileExcel = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', filled = true, ...other } = props;

  if (!filled) {
    console.debug('IconFileExcel needs to be created also as outlined icon');
  }

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C11.8879 2.00068 11.7761 2.01268 11.6663 2.03581L11.6647 2.03418L3.35742 3.69596L3.35579 3.69759C2.9748 3.76993 2.63095 3.97285 2.38348 4.27143C2.136 4.57 2.00039 4.94553 2 5.33333V18.6667C2.00008 19.055 2.13575 19.4311 2.38358 19.73C2.63142 20.029 2.97585 20.232 3.35742 20.304L11.6647 21.9658C11.775 21.9885 11.8874 22 12 22C12.442 22 12.866 21.8244 13.1785 21.5118C13.4911 21.1993 13.6667 20.7754 13.6667 20.3333V3.66667C13.6667 3.22464 13.4911 2.80072 13.1785 2.48816C12.866 2.17559 12.442 2 12 2ZM15.3333 3.66667V6.16667H17V7.83333H15.3333V9.5H17V11.1667H15.3333V12.8333H17V14.5H15.3333V16.1667H17V17.8333H15.3333V20.3333H20.3333C21.2542 20.3333 22 19.5875 22 18.6667V5.33333C22 4.4125 21.2542 3.66667 20.3333 3.66667H15.3333ZM18.6667 6.16667H19.5C19.96 6.16667 20.3333 6.54 20.3333 7C20.3333 7.46 19.96 7.83333 19.5 7.83333H18.6667V6.16667ZM4.65462 7.83333H6.65658L7.69336 10.3252C7.77753 10.5285 7.84483 10.7641 7.90983 11.0316H7.9375C7.975 10.8707 8.04878 10.6265 8.16211 10.3057L9.32096 7.83333H11.1439L8.96615 11.9626L11.209 16.165H9.264L8.01074 13.4502C7.96324 13.3544 7.90767 13.1611 7.861 12.8936H7.8431C7.81477 13.0219 7.75883 13.2155 7.67383 13.473L6.41243 16.1667H4.45768L6.77702 11.9951L4.65462 7.83333ZM18.6667 9.5H19.5C19.96 9.5 20.3333 9.87333 20.3333 10.3333C20.3333 10.7933 19.96 11.1667 19.5 11.1667H18.6667V9.5ZM18.6667 12.8333H19.5C19.96 12.8333 20.3333 13.2067 20.3333 13.6667C20.3333 14.1267 19.96 14.5 19.5 14.5H18.6667V12.8333ZM18.6667 16.1667H19.5C19.96 16.1667 20.3333 16.54 20.3333 17C20.3333 17.46 19.96 17.8333 19.5 17.8333H18.6667V16.1667Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

IconFileExcel.propTypes = {
  color: PropTypes.string,
  filled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconFileExcel;
